import Pages from "./pages";
import Login from "./pages/login";
import siderPage from "./components/siderPage";
import ErrorPage from './pages/errorPage'
import outPage from './pages/outPage'
import MedicalReport from './pages/medicalReport'
import Electrocardiogram from './pages/electrocardiogram'
const router = [
  { path: "/", name: "Login", component: Login },
  { path: "/pages", name: "Pages", component: Pages, auth: true },
  { path: "/siderPage", name: "siderPage", component: siderPage, auth: true },
  { path: "/medicalReport", name: "MedicalReport", component: MedicalReport, auth: true },
  { path: "/electrocardiogram", name: "electrocardiogram", component: Electrocardiogram, auth: true },
  { path: "/login", name: "Login", component: Login },
  { path: "/404", name: "404", component: ErrorPage },
  { path: "/403", name: "403", component: outPage },
]

export default router
